export default {
  dashboard: {
    icon: require("@/assets/i/white/icon-dashboard.svg"),
    iconHover: require("@/assets/i/gray/icon-dashboard.svg"),
    titleEs: "Dashboard",
    titleEn: "Dashboard",
    to: "/brand/dashboard"
  },
  boxStock: {
    icon: require("@/assets/i/white/pallet-tracking.svg"),
    iconHover: require("@/assets/i/gray/pallet-tracking.svg"),
    titleEs: "Pallet tracking",
    titleEn: "Seguimiento de palés",
    to: "/brand/pallet-tracking"
  },
  boxTracking: {
    icon: require("@/assets/i/white/box.svg"),
    iconHover: require("@/assets/i/gray/box.svg"),
    titleEs: "Box tracking",
    titleEn: "Seguimiento de cajas",
    to: "/brand/box-tracking"
  }
};
